// Depending on whether rollup is used, needs to be imported differently.
// Since doesn't have a default export, we normally need to import using the `* as` syntax.
// However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as momentNormal from "moment";
// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import { default as rollupMoment, _MomentOgUnused } from "moment";

export const moment = rollupMoment || momentNormal;
